import { Component, Input, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import {
  BackgroundColor,
  CmsImage,
  FlexAlignment,
  Image,
  ImageLoadingMethod,
  ImageOverlayStyle,
  VideoModal,
} from '@digital-platform/rs-cms/domain';
import { ImageLoading } from '@digital-platform/rs-shared/domain';
import { DomManipulationService } from '@digital-platform/rs-shared/ui';
import { BasePTypeComponent } from '../base-ptype/base-ptype.component';
import { ImageComponent } from '../image/image.component';
import { YoutubeService } from '../services/youtube.service';
import { YoutubeVideoComponent } from '../youtube-video/youtube-video.component';

@Component({
  standalone: true,
  selector: 'digital-platform-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss'],
  imports: [ImageComponent],
  providers: [NgbModal, YoutubeService, DomManipulationService],
})
export class VideoModalComponent
  extends BasePTypeComponent
  implements VideoModal
{
  public override type = 'videoModal' as const;

  public defaultImageLoading = {
    tid: 5943,
    name: 'Eager',
    value: ImageLoading.enum.eager,
  };

  public emptyCmsWebpImage: CmsImage = {
    target_id: null,
    image_use: null,
    alt: null,
    title: null,
    width: null,
    height: null,
    src: '',
  };

  public emptyImagePtype: Image = {
    id: undefined,
    uuid: null,
    revisionId: undefined,
    type: 'image' as const,
    status: true,
    parentType: '',
    behaviorSettings: [],
    analyticsLinkText: null,
    imageHeight: null,
    imageSize: {
      tid: undefined,
      name: '',
      imageStyleName: '',
    },
    imageSizeMobile: {
      tid: undefined,
      name: '',
      imageStyleName: '',
    },
    imageWidth: null,
    url: [],
    webpMedia: this.emptyCmsWebpImage,
    webpMediaMid: this.emptyCmsWebpImage,
    webpMediaDesktop: this.emptyCmsWebpImage,
  };

  @Input() public bgColor: BackgroundColor | null = {};
  @Input() public description: string | null = '';
  @Input() public flexAlignment: FlexAlignment | null = {};
  @Input() public loading: ImageLoadingMethod | null = this.defaultImageLoading;
  @Input() public overlayText: string | null = '';
  @Input() public alignment: string | null = '';
  @Input() public imageLoading: string | null = '';
  @Input() public imageStyle: ImageOverlayStyle | null = null;
  @Input() public title: string | null = '';
  @Input() public videoOverlay: Image[] = [];
  @Input() public videoUrl = '';

  private modalService = inject(NgbModal);

  playVideo() {
    const modalRef = this.modalService.open(YoutubeVideoComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.videoId = this.videoUrl;
  }

  get sureVideoOverlay(): Image {
    return this.videoOverlay?.[0] ?? this.emptyImagePtype;
  }
}
